function nonnegativeNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : 0;
}

/**
 * Selects telemetry from the renderer that currently owns the camera.
 * Virtual-camera mode must report native CEF paint cadence, not the hidden
 * preview iframe's frame counter or LensCore's internal callback cadence.
 */
export function selectDisplayedRenderTelemetry({
  cameraMode,
  previewFps,
  previewFrameCount,
  runtimeStatus,
}) {
  if (cameraMode !== "virtual-camera") {
    return {
      fps: nonnegativeNumber(previewFps),
      frameCount: Math.floor(nonnegativeNumber(previewFrameCount)),
      source: "preview",
    };
  }

  const render = runtimeStatus?.connected ? runtimeStatus?.status?.render : null;
  return {
    fps: nonnegativeNumber(render?.paintFps),
    frameCount: Math.floor(nonnegativeNumber(render?.cefFrames)),
    source: "native-cef",
  };
}
